import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../../utils/constants';
import { hasPermission, isCXUser } from '../../utils/permissions';
import { commonService } from '../../services/commonService';
import FDCCreateWizard from '../../pages/DataCenter/FDC/FDCCreateWizard';
import '../../assets/styles/Workflow.css';

interface FDCSideRailProps {
  // Mobile-only off-canvas state. Fully optional/inert on desktop - undefined
  // props mean "wf-rail-open" is never applied and no backdrop renders, so
  // desktop callers don't need to change.
  mobileOpen?: boolean;
  onCloseMobile?: () => void;
}

const FDCSideRail: React.FC<FDCSideRailProps> = ({ mobileOpen, onCloseMobile }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [projectCount, setProjectCount] = useState<number | null>(null);
  const [wizardOpen, setWizardOpen] = useState(false);

  useEffect(() => {
    commonService.fdcList({ page: 1, page_size: 1 })
      .then((res) => setProjectCount(res?.total ?? null))
      .catch(() => setProjectCount(null));
  }, []);

  const isActive = (path: string) => location.pathname === path;

  const goTo = (path: string) => {
    navigate(path);
    onCloseMobile?.();
  };

  return (
    <>
      {mobileOpen && <div className="wf-rail-backdrop" onClick={onCloseMobile} />}
      <div className={`wf-rail ${mobileOpen ? 'wf-rail-open' : ''}`}>
        <div className="wf-navgroup-label">Workspace</div>
        <button
          onClick={() => goTo(ROUTES.FDC_PROJECTS)}
          className={`wf-navitem ${isActive(ROUTES.FDC_PROJECTS) ? 'active' : ''}`}
        >
          <span className="wf-ic">▤</span> FDC Projects
          {projectCount !== null && <span className="wf-count">{projectCount}</span>}
        </button>

        {isCXUser() && (
          <button
            onClick={() => goTo(ROUTES.FDC_CUSTOMER_EXPERIENCE)}
            className={`wf-navitem ${isActive(ROUTES.FDC_CUSTOMER_EXPERIENCE) ? 'active' : ''}`}
          >
            <span className="wf-ic">💬</span> Customer Experience
          </button>
        )}

        {isCXUser() && (
          <button
            onClick={() => goTo(ROUTES.FDC_REGISTER_CUSTOMER)}
            className={`wf-navitem ${isActive(ROUTES.FDC_REGISTER_CUSTOMER) ? 'active' : ''}`}
          >
            <span className="wf-ic">➕</span> Register Customer
          </button>
        )}

        {hasPermission('fdc_project:create') && (
          <>
            <div className="wf-navgroup-label">Shortcuts</div>
            <button onClick={() => { setWizardOpen(true); onCloseMobile?.(); }} className="wf-navitem">
              <span className="wf-ic">+</span> New Project
            </button>
          </>
        )}

        {wizardOpen && (
          <FDCCreateWizard
            onClose={() => setWizardOpen(false)}
            onCreated={() => {
              setWizardOpen(false);
              commonService.fdcList({ page: 1, page_size: 1 })
                .then((res) => setProjectCount(res?.total ?? null))
                .catch(() => setProjectCount(null));
              navigate(ROUTES.FDC_PROJECTS, { state: { refresh: Date.now() } });
            }}
          />
        )}
      </div>
    </>
  );
};

export default FDCSideRail;
